import type { ReactNode } from 'react';
import { Dropdown, Option } from '@fluentui/react-components';
import MultiselectSummary from './MultiselectSummary';

export type TStatusDropdownOption = {
  value: string;
  label: string;
  icon: ReactNode;
};

type TProps = {
  options: TStatusDropdownOption[];
  selectedOptions: string[];
  onSelect: (values: string[]) => void;
  multiselect?: boolean;
  placeholder?: string;
  className?: string;
};

// A dropdown whose options and closed field show an icon beside the label, such as a status square or a user avatar.
// Multiselect summarises the closed field like every filter-bar multiselect: as many as fit, then "+N".
export const StatusDropdown = ({ options, selectedOptions, onSelect, multiselect, placeholder, className }: TProps) => {
  const selected = options.filter((option) => selectedOptions.includes(option.value));

  return (
    <Dropdown
      multiselect={multiselect}
      selectedOptions={selectedOptions}
      placeholder={placeholder}
      button={
        selected.length > 0 ? (
          <MultiselectSummary
            items={selected.map((option) => ({
              value: option.value,
              content: (
                <span className="flex min-w-0 items-center gap-1">
                  <span className="flex shrink-0">{option.icon}</span>
                  <span className="truncate">{option.label}</span>
                </span>
              ),
            }))}
          />
        ) : undefined
      }
      className={className}
      onOptionSelect={(_, data) => onSelect(data.selectedOptions)}
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value} text={option.label}>
          <span className="flex items-center space-x-1">
            {option.icon}
            <span>{option.label}</span>
          </span>
        </Option>
      ))}
    </Dropdown>
  );
};
